import { C3ProductType } from '../enums/c3-product-type.enum';

export const C3_ASSEMBLY_STATE_PAYLOAD_VERSION = 1;
export const C3_ASSEMBLY_RECENT_COMMAND_LIMIT = 100;
export const C3_ASSEMBLY_MAX_PAYLOAD_CHARACTERS = 60_000;

export enum C3AssemblySessionStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  StoppedInsufficientBom = 'StoppedInsufficientBom',
  Exited = 'Exited',
}

export interface C3AssemblyProductSnapshot {
  productId: string;
  productVersionId: string;
  partNumber: string;
  description: string;
  imageUrl: string;
  type: C3ProductType;
}

export interface C3AssemblyBomSnapshotItem {
  entityId: string;
  type: 'Hardware' | 'Product';
  partNumber: string;
  description: string;
  imageUrl: string;
  quantityPerProduct: number;
}

export interface C3AssemblyDiscardedComponent {
  hardwareItemId: string;
  partNumber: string;
  description: string;
  imageUrl: string;
  quantity: number;
}

interface C3AssemblySessionBase {
  id: string;
  product: C3AssemblyProductSnapshot;
  targetQuantity: number;
  completedQuantity: number;
  startedOn: Date;
  bomSnapshot: C3AssemblyBomSnapshotItem[];
  discardedComponents: C3AssemblyDiscardedComponent[];
}

export interface C3AssemblyActiveSession extends C3AssemblySessionBase {
  status: C3AssemblySessionStatus.InProgress;
  recentCommandIds: string[];
}

export interface C3AssemblyCompletedSession extends C3AssemblySessionBase {
  status:
    | C3AssemblySessionStatus.Completed
    | C3AssemblySessionStatus.StoppedInsufficientBom
    | C3AssemblySessionStatus.Exited;
  endedOn: Date;
  durationSeconds: number;
}

export type C3AssemblySession =
  | C3AssemblyActiveSession
  | C3AssemblyCompletedSession;

export interface C3AssemblyGlobalState {
  payloadVersion: typeof C3_ASSEMBLY_STATE_PAYLOAD_VERSION;
  activeSession: C3AssemblyActiveSession | null;
}

export const EMPTY_C3_ASSEMBLY_GLOBAL_STATE: C3AssemblyGlobalState = {
  payloadVersion: C3_ASSEMBLY_STATE_PAYLOAD_VERSION,
  activeSession: null,
};

export interface C3AssemblyBomHardware {
  hardwareItemId: string;
  quantityPerProduct: number;
}

export interface StartC3AssemblyTaskRequest {
  commandId: string;
  productVersionId: string;
  targetQuantity: number;
}

export interface C3AssemblyTaskCommandRequest {
  commandId: string;
  taskId: string;
}

export interface DiscardC3AssemblyHardwareRequest
  extends C3AssemblyTaskCommandRequest {
  hardwareItemId: string;
  quantity: number;
}

export interface C3AssemblyTaskCommandResponse {
  session: C3AssemblySession;
  reportId?: string;
  replayed?: boolean;
}

export function c3AssemblyDiscardedQuantity(
  session: Pick<C3AssemblySessionBase, 'discardedComponents'>
): number {
  return session.discardedComponents.reduce(
    (total, component) => total + component.quantity,
    0
  );
}
